import { render, staticRenderFns } from "./Counseling.vue?vue&type=template&id=2b919fe2&scoped=true"
import script from "./Counseling.vue?vue&type=script&lang=js"
export * from "./Counseling.vue?vue&type=script&lang=js"
import style0 from "./Counseling.vue?vue&type=style&index=0&id=2b919fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b919fe2",
  null
  
)

export default component.exports